import CONFIG from '../config'
const uploadAppIcon = (params) => {
  // console.log("Promise uploadLogo: ", params);
  return new Promise((resolve, reject) => {
    if (params.data.app_icon && params.data.app_icon && params.data.app_icon.rawFile instanceof File) {
      // console.log('test == file')
      const formData = new FormData();
      formData.append('file', params.data.app_icon.rawFile);
      const token = localStorage.getItem('token');

      fetch(`${CONFIG.API}/files/one`, {
        method: 'post',
        headers: {
          'Authorization': token
        },
        body: formData,
      })
        .then(response => response.json())
        .then(image => {
          // console.log(logo);
          const tmp = {
            ...params,
            data: {
              ...params.data,
              app_icon: image.url
            }
          }
          // console.log("tmp", tmp);
          resolve(tmp)
        });
    } else {
      // console.log("tmp", params);
      resolve(params);
    }
  });
};

const uploadBanner = (params) => {
  // console.log("Promise uploadLogo: ", params);
  return new Promise((resolve, reject) => {
    if (params.data.app_banner && params.data.app_banner && params.data.app_banner.rawFile instanceof File) {
      // console.log('test == file')
      const formData = new FormData();
      formData.append('file', params.data.app_banner.rawFile);
      const token = localStorage.getItem('token');

      fetch(`${CONFIG.API}/files/one`, {
        method: 'post',
        headers: {
          'Authorization': token
        },
        body: formData,
      })
        .then(response => response.json())
        .then(image => {
          // console.log(logo);
          const tmp = {
            ...params,
            data: {
              ...params.data,
              app_banner: image.url
            }
          }
          // console.log("tmp", tmp);
          resolve(tmp)
        });
    } else {
      // console.log("tmp", params);
      resolve(params);
    }
  });
};

const uploadPhotos = (params) => {
  // console.log("Promise uploadPhotos111 ", params);
  return new Promise((resolve, reject) => {
    if (params.data.photos && params.data.photos.length) {
      // console.log("ok in prase 1");
      const photos = params.data.photos.filter(photo => photo && photo.rawFile instanceof File);
      const oldPhotos = params.data.photos.filter(photo => photo && !(photo.rawFile instanceof File));

      if (photos.length) {
        const formData = new FormData();
        // photos.map(photo => )
        photos.map(photo => formData.append('photos', photo.rawFile))
        // console.log("addUploadCapabilities photos: ", photos);
        const token = localStorage.getItem('token');
        // console.log("formData", formData);
        return fetch(`${CONFIG.API}/files/multi`, {
          method: 'post',
          headers: {
            'Authorization': token
          },
          body: formData,
        })
          .then(response => response.json())
          .then(photos => {
            params = {
              ...params,
              data: {
                ...params.data,
                photos: [...oldPhotos, ...photos.data]
              }
            }
            resolve(params);
          });
      } else {
        resolve(params);
      }
    } else {
      resolve(params);
    }
  });
};

const uploadMusicBackgroundUrl = (params) => {
  // console.log("Promise uploadLogo: ", params);
  return new Promise((resolve, reject) => {
    if (params.data.background_url && params.data.background_url && params.data.background_url.rawFile instanceof File) {
      // console.log('test == file')
      const formData = new FormData();
      formData.append('file', params.data.background_url.rawFile);
      const token = localStorage.getItem('token');

      fetch(`${CONFIG.API}/files/one`, {
        method: 'post',
        headers: {
          'Authorization': token
        },
        body: formData,
      })
        .then(response => response.json())
        .then(image => {
          // console.log(logo);
          const tmp = {
            ...params,
            data: {
              ...params.data,
              background_url: image.url
            }
          }
          // console.log("tmp", tmp);
          resolve(tmp)
        });
    } else {
      // console.log("tmp", params);
      resolve(params);
    }
  });
};

const uploadAudio = (params) => {
  console.log("Promise audio: ", params);
  return new Promise((resolve, reject) => {
    if (params.data.url && params.data.url && params.data.url.rawFile instanceof File) {
      // console.log('test == file')
      const formData = new FormData();
      formData.append('file', params.data.url.rawFile);
      const token = localStorage.getItem('token');

      fetch(`${CONFIG.API}/files/file`, {
        method: 'post',
        headers: {
          'Authorization': token
        },
        body: formData,
      })
        .then(response => response.json())
        .then(image => {
          // console.log(logo);
          const tmp = {
            ...params,
            data: {
              ...params.data,
              url: image.url
            }
          }
          // console.log("tmp", tmp);
          resolve(tmp)
        });
    } else {
      // console.log("tmp", params);
      resolve(params);
    }
  });
};

const addUploadCapabilities = requestHandler => (type, resource, params) => {
  if ((type === 'UPDATE' || type === "CREATE") &&
    (resource === 'screens' || resource === 'meals' || resource === 'music-categories' || resource === 'audio')) {
    console.log("addUploadCapabilities: ", params.data);
    if (Object.prototype.toString.call(params.data.value) === '[object Array]') {
      // console.log("addUploadCapabilities length: ", params.data.logo.length);
    } else {
      // console.log("addUploadCapabilities length: 0");
    }

    return uploadAppIcon(params)
      .then(uploadBanner)
      .then(uploadPhotos)
      .then(uploadMusicBackgroundUrl)
      .then(uploadAudio)
      .then(params => requestHandler(type, resource, params))
      .catch(error => { throw new Error(error.message); });
  } else {
    return requestHandler(type, resource, params);
  }
}

export default addUploadCapabilities;
